export default "__VITE_ASSET__NcuJqAzF__"